// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import Cookies from "js-cookie";

// Import translation files
import translationEN from "./locales/en/translation.json";
import translationAR from "./locales/ar/translation.json";

// Translation resources
const resources = {
  en: { translation: translationEN },
  ar: { translation: translationAR },
};

// Initialize i18n
i18n
  .use(initReactI18next)
  .use(HttpApi)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en', // Fallback to English
    lng: 'en', // Default language is English
    resources,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ["htmlTag", "cookie", "localStorage", "sessionStorage", "navigator", "path", "subdomain"],
      caches: ["cookie"], // Cache language preferences in cookies
    },
  })
  .then(() => {
    // Set initial language and direction
    const currentLang = i18n.language || "en";
    updateDirection(currentLang);
  });

// Function to update the direction based on language
function updateDirection(language) {
  const htmlElement = document.documentElement;

  if (language.startsWith("ar")) {
    htmlElement.setAttribute("dir", "rtl"); // Right-to-left for Arabic
  } else {
    htmlElement.setAttribute("dir", "ltr"); // Left-to-right for other languages
  }
}

// Function to change language and update direction
export function changeLanguage(language) {
  i18n.changeLanguage(language); // Notify i18next of the language change
  updateDirection(language); // Adjust direction
}

export default i18n;
